import axios from 'axios';
import { toast } from 'react-toastify';

const { REACT_APP_BASE_API, REACT_APP_TOKEN } = process.env;

export const api = axios.create({
  baseURL: REACT_APP_BASE_API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    clientSide: 'web'
  }
});

export const setAPI = () => {
  api.defaults.headers.common['Authorization'] = REACT_APP_TOKEN;

  api.interceptors.response.use(null, error => {
    if(error.response) {
      if(error.response.status === 500) {
        toast.error('Erro no servidor.');
      } else if (error.response.status === 400) {
        toast.error(error.response.data.data.msg);
      } else if (error.response.status === 401) {
        window.location.href = '/?notauthorized=true';
      } else {
        toast.error('Estamos tendo problemas, tente novamente em breve.');
      }
    }

    return Promise.reject(error);
  });
}


// WEBPACK FOOTER //
// ./src/routes/api/index.js